
import React, { useMemo } from 'react';
import { Button } from 'primereact/button';
import useLaborCatalogReport from './hooks/useLaborCatalogReport';
import LaborCatalogTable from './components/LaborCatalogTable';
import { useLanguage } from '../../../contexts/LanguageContext';
import { getLaborCatalogColumns } from './helpers/getLaborCatalogColumns';
import { useLazyExportLaborCatalogReportToExcelQuery } from '../../../api/endpoints/laborCatalog';
import GenericFileExportButton from '../../../components/common/GenericFileExportButton';


export default function LaborCatalogReportPage() {
    const { th } = useLanguage();

    const {
        items,
        totalCount,
        isFetching,
        lazyParams,
        onPage,
        activeFilters,
        handleFilterChange,
        resetFilters,
        sortField,
        sortOrder,
        onSort,
        exportParams
    } = useLaborCatalogReport();

    const columns = useMemo(() => getLaborCatalogColumns(th), [th]);

    return (
        <div className="card">
            <div className="flex justify-content-between align-items-center mb-4">
                <h1 className="m-0">{th('laborCatalogReport.title')}</h1>
                 <div className="flex gap-2">
                <Button
                    icon="pi pi-filter-slash"
                    className="p-button-outlined p-button-secondary"
                    onClick={resetFilters}
                    tooltip={th('filter.reset')}
                    tooltipOptions={{ position: 'left' }}
                />
                 <GenericFileExportButton
                        useExportQuery={useLazyExportLaborCatalogReportToExcelQuery}
                        exportParams={exportParams}
                        buttonLabel={th('common.export')}
                        buttonClassName="p-button-success"
                        icon="pi pi-file-excel"
                        defaultFileName="IscilikKatalogu"
                    />
                </div>
            </div>

            <LaborCatalogTable
                items={items}
                totalCount={totalCount}
                loading={isFetching}
                lazyParams={lazyParams}
                onPage={onPage}
                columns={columns}
                sortField={sortField}
                sortOrder={sortOrder}
                onSortChange={onSort}
                activeFilters={activeFilters}
                onFiltersChange={handleFilterChange}
            />

            {!isFetching && items.length === 0 && (
                <div className="flex justify-content-center align-items-center p-5">
                    <p className="text-500">{th('common.noRecords')}</p>
                </div>
            )}
        </div>
    );
}